// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/carousel/style/index.less
// module id = 1019
// module chunks = 1